import { render } from "./InfoEditForm.vue?vue&type=template&id=8c1cdfa0&scoped=true"
import script from "./InfoEditForm.vue?vue&type=script&lang=ts"
export * from "./InfoEditForm.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-8c1cdfa0"

export default script